import { UserDataStore } from '@/store/user-store/user-data.store';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, firstValueFrom, map, take } from 'rxjs';

export const agroGuard: CanActivateFn = async () => {
  const userStore = inject(UserDataStore);
  const router = inject(Router);

  return await firstValueFrom(
    toObservable(userStore.isLoaded).pipe(
      filter(loaded => loaded),
      take(1),
      map(() => {
        const canPass = userStore.isAgroFuels() || userStore.isAgroLubes();

        return canPass ? true : router.createUrlTree(['/portal/home']);
      }),
    ),
  );
};
